import { Image, TextLink, TextPassage } from '@petsmart-ui/sparky';

import { useServicesLinkClick } from '../../../../shared';

import './service-card.scss';

export type ServiceCardModel = {
    href: string;
    imageUrl: string;
    openInNewTab?: boolean;
    title: string;
};

type ServiceCardProps = {
    card: ServiceCardModel;
    onClick?: () => void;
};

export function ServiceCard({ card, onClick }: ServiceCardProps) {
    const handleServicesLinkClick = useServicesLinkClick();

    return (
        <TextLink
            href={card.href}
            className="service-card"
            rel={card.openInNewTab ? 'noopener noreferrer' : undefined}
            target={card.openInNewTab ? '_blank' : undefined}
            onClick={event => {
                handleServicesLinkClick({
                    event,
                    link: card.href,
                    shouldOpenInNewTab: card.openInNewTab,
                });
                onClick?.();
            }}
        >
            <Image src={card.imageUrl} alt="" className="service-card__image" loading="lazy" />
            <TextPassage className="service-card__title" align="center">
                {card.title}
            </TextPassage>
        </TextLink>
    );
}
